import { post } from "../base";
import { get } from "../base";
import { phoneReg } from "../../common/js/phone_number_check"
// 注册机构中所有的下拉
export async function registerSelectInfo() {
    let respObj = await get("/org/registerSelectInfo");
    return respObj;
}

// 获取手机号验证码
export function getVerifyCode(phoneNum) {
    if (phoneReg.test(phoneNum) == false) {
        alert("请输入正确的手机号");
        return false;
    }
    return get(`/edu-classroom/user/sendsms/${phoneNum}`);
}

//验证手机验证码  /account/13792894253/9059
export async function yzCode(phone,code) {
    let params = {
        phone: phone,
        code: code,
    }
    let respObj = await get("/org/registerCheckPhone",params);
    return respObj;
}

//区市联动
export function registerRegionInfo(params) {
    let respObj = get("/org/registerRegionInfo", params);
    return respObj;
}

//获取七牛云图片token
export function getPictureToken(){
    return get("/api/oss/picture/token")
}
//获取七牛云视频token
export function getVideoToken() {
    return get("/api/oss/video/token")
  }

//机构注册
export async function registerSub(params){
    return await post('/org/register', params);
}